import React, { useEffect, useMemo, useState } from "react";
import DesktopConsole from "./DesktopConsole";
import MobileConsole from "./MobileConsole";
import GoToTop from "../components/GoToTop";
import { useNavigate } from "react-router-dom";
import "../styles/testconsole.css";

const MOBILE_BREAKPOINT = 768;

const TestConsole = ({
  quesData,
  catName,
  type,
  testId,
  MyTimer,
  time,
  timeExpired,
  rankArray,
}) => {

  const [curQues, SetcurQues] = useState(0);
  const [ansArray, SetansArray] = useState([]);
  const [visitedArr, SetVisitedArray] = useState([]);
  




const [showConfirm,setShowConfirm]=useState(false);


const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 

  const setAnswer = (answer) => {
    const newArr = [...ansArray];
    newArr[curQues] = answer;
    SetansArray(newArr);
  };

  const syncRadioButtons = (questionIndex) => {
    const a = document.getElementById("optiona");
    const b = document.getElementById("optionb");
    const c = document.getElementById("optionc");
    const d = document.getElementById("optiond");

    if (!quesData[questionIndex]) return;

    if (a)
      a.checked =
        ansArray[questionIndex] === quesData[questionIndex].Option1;

    if (b)
      b.checked =
        ansArray[questionIndex] === quesData[questionIndex].Option2;

    if (c)
      c.checked =
        ansArray[questionIndex] === quesData[questionIndex].Option3;

    if (d)
      d.checked =
        ansArray[questionIndex] === quesData[questionIndex].Option4;
  };

  const nextQues = () => {
    if (curQues >= quesData.length - 1) return;

    const newVisited = [...visitedArr];
    newVisited[curQues] = curQues;
    SetVisitedArray(newVisited);

    const next = curQues + 1;

    SetcurQues(next);

    setTimeout(() => {
      syncRadioButtons(next);
    }, 0);
  };

  const preQues = () => {
    if (curQues <= 0) return;

    const newVisited = [...visitedArr];
    newVisited[curQues] = curQues;
    SetVisitedArray(newVisited);

    const prev = curQues - 1;

    SetcurQues(prev);

    setTimeout(() => {
      syncRadioButtons(prev);
    }, 0);
  };

  const clearResponse = () => {
    ["optiona", "optionb", "optionc", "optiond"].forEach((id) => {
      const el = document.getElementById(id);

      if (el) {
        el.checked = false;
      }
    });

    const newArr = [...ansArray];
    newArr[curQues] = null;
    SetansArray(newArr);
  };

  const setQues = (index) => {

    const newVisited = [...visitedArr];
    newVisited[curQues] = curQues;
    SetVisitedArray(newVisited);

    SetcurQues(index);

    setTimeout(() => {
      syncRadioButtons(index);
    }, 0);
  };

     const submitTest = () => {

    navigate(
        `/online-practice-test-result/${catName.replaceAll(" ","-")}`,
        {
          replace: true,
            state:{
                ansArray,
                catName,
                quesData,
                type,
                testId,
                rankArray
            }
        }
    );

};

const handleSubmitClick=()=>{
 console.log("handleSubmitClick");
    setShowConfirm(true);

};

  const consoleProps = useMemo(
    () => ({
       
      quesData,
      catName,
      type,
      testId,

      MyTimer,
      time,
      timeExpired,
      rankArray,

      curQues,
      ansArray,
      visitedArr,

      setAnswer,
      nextQues,
      preQues,
      clearResponse,
      setQues,
     onSubmitClick: handleSubmitClick
    }),
    [
      quesData,
      catName,
      type,
      testId,
      MyTimer,
      time,
      timeExpired,
      rankArray,
      curQues,
      ansArray,
      visitedArr,
      handleSubmitClick
    ]
  );





  useEffect(()=>{

    if(timeExpired!==0){

        submitTest();

    }

},[timeExpired]);

   if (!quesData || quesData.length === 0) {
    return null;
  }


 


  return (
    <>
      <GoToTop />

      {showConfirm && (

<div className="modal-backdrop">

<div className="modal-card">

<div className="modal-header">

<div className="modal-title">

Submit Your Exam?

</div>

<button
className="modal-close"
onClick={()=>setShowConfirm(false)}
>

✕

</button>

</div>

<div className="modal-body">

<p className="modal-summary-text">

You've answered

<strong>

{" "}
{ansArray.filter(x=>x!=null).length}
{" "}

</strong>

out of

<strong>

{" "}
{quesData.length}
{" "}

</strong>

questions.

</p>

<h4 className="exam-summary-heading">

Exam Summary

</h4>

<table className="summary-table">

<tbody>

<tr>

<th>Time Left</th>

<td>

<MyTimer expiryTimestamp={time}/>

</td>

</tr>

<tr>

<th>Attempted</th>

<td className="pos">

{ansArray.filter(x=>x!=null).length}

</td>

</tr>

<tr>

<th>Remaining</th>

<td className="neg">

{quesData.length-ansArray.filter(x=>x!=null).length}

</td>

</tr>

</tbody>

</table>

</div>

<div className="modal-actions">

<button
className="ghost-btn"
onClick={()=>setShowConfirm(false)}
>

Continue Exam

</button>

<button
className="primary-btn"
onClick={submitTest}
>

Submit Exam

</button>

</div>

</div>

</div>

)}

      {isMobile ? (
        <MobileConsole {...consoleProps} />
      ) : (
        <DesktopConsole {...consoleProps} />
      )}
    </>
  );
};

export default TestConsole;